import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TLocation } from '../../core/entities';
import { TDevice } from '../../thinkdesks/thinkdesks.entities';
import { AccessLogListComponent } from './access.log.list.component';


@Component({
  selector: 'app-access-log-dialog',
  templateUrl: './access.log.dialog.html',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    MatDialogModule,
    AccessLogListComponent,
  ],
})
export class AccessLogDialog implements OnInit {
  _common = _common;

  object: TDevice;
  location: TLocation
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,

    public dialogRef: MatDialogRef<AccessLogDialog>
  ) {
    this.object = this.data.object;
    this.location = this.data.location
  }

  ngOnInit(): void { }

  save() {

  }
  cancel() {
    this.dialogRef.close();
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
